module.exports = __webpack_public_path__ + "img/DK25370457.9795800e.svg";